import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/privacy-policy/archive/components/detail/index.tsx");
